"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.countriesForContinent = exports.continentsForCountry = void 0;
const countryContinentMapping = new Map([
    ["1", ["1"]],
    ["2", ["1"]],
    ["3", ["1"]],
    ["4", ["1"]],
    ["5", ["1", "9"]],
    ["6", ["1"]],
    ["7", ["1"]],
    ["8", ["1"]],
    ["9", ["1"]],
    ["10", ["1"]],
    ["11", ["1"]],
    ["12", ["1"]],
    ["13", ["1"]],
    ["14", ["1"]],
    ["15", ["1"]],
    ["16", ["1"]],
    ["17", ["1"]],
    ["18", ["1"]],
    ["19", ["1"]],
    ["20", ["1"]],
    ["21", ["1"]],
    ["22", ["1"]],
    ["23", ["1"]],
    ["24", ["1"]],
    ["25", ["1"]],
    ["26", ["1"]],
    ["27", ["1"]],
    ["28", ["1", "9"]],
    ["29", ["1"]],
    ["30", ["1"]],
    ["31", ["1"]],
    // 32 not valid
    ["33", ["1"]],
    ["34", ["1"]],
    ["35", ["1"]],
    ["36", ["1"]],
    ["37", ["1"]],
    ["38", ["1"]],
    ["39", ["1"]],
    ["40", ["1"]],
    ["41", ["1"]],
    ["42", ["1"]],
    ["43", ["1"]],
    ["44", ["1"]],
    ["45", ["1"]],
    ["46", ["1"]],
    ["47", ["1"]],
    ["48", ["1"]],
    ["49", ["11"]],
    ["50", ["11"]],
    ["51", ["11"]],
    ["52", ["11"]],
    ["53", ["11"]],
    ["54", ["11"]],
    ["55", ["11"]],
    ["56", ["11"]],
    ["57", ["11"]],
    ["58", ["11"]],
    ["59", ["11"]],
    ["60", ["11"]],
    ["61", ["11"]],
    ["62", ["11"]],
    ["63", ["11"]],
    ["64", ["11"]],
    ["65", ["11"]],
    ["66", ["11"]],
    ["67", ["11"]],
    ["68", ["11"]],
    ["69", ["11"]],
    ["70", ["11"]],
    ["71", ["11"]],
    ["72", ["11"]],
    // 73 not valid
    ["74", ["11"]],
    ["75", ["11"]],
    ["76", ["11"]],
    ["77", ["11"]],
    ["78", ["11"]],
    ["79", ["11"]],
    ["80", ["11"]],
    ["81", ["11"]],
    ["82", ["11"]],
    ["83", ["11"]],
    ["84", ["13"]],
    ["85", ["13"]],
    ["86", ["13"]],
    ["87", ["13"]],
    ["88", ["11", "13"]],
    ["89", ["13"]],
    ["90", ["11", "13"]],
    ["91", ["11", "13"]],
    ["92", ["13"]],
    ["93", ["13"]],
    ["94", ["11", "13"]],
    ["95", ["13"]],
    ["96", ["11", "13"]],
    ["97", ["9"]],
    ["98", ["1", "9"]],
    ["99", ["9"]],
    ["100", ["9"]],
    ["101", ["9"]],
    ["102", ["9"]],
    ["103", ["9"]],
    ["104", ["9"]],
    ["105", ["9"]],
    ["106", ["9"]],
    ["107", ["9"]],
    ["108", ["9"]],
    ["109", ["9"]],
    ["110", ["9"]],
    ["111", ["9"]],
    ["112", ["9"]],
    ["113", ["9"]],
    ["114", ["9"]],
    ["115", ["9"]],
    ["116", ["9"]],
    ["117", ["9"]],
    ["118", ["9"]],
    ["119", ["9"]],
    ["120", ["9"]],
    ["121", ["9"]],
    ["122", ["9"]],
    ["123", ["9"]],
    ["124", ["9"]],
    ["125", ["9"]],
    ["126", ["9"]],
    ["127", ["9"]],
    ["128", ["9"]],
    ["129", ["9"]],
    ["130", ["9"]],
    ["131", ["9"]],
    ["132", ["9"]],
    ["133", ["9"]],
    ["134", ["9"]],
    ["135", ["9"]],
    ["136", ["9"]],
    ["137", ["9"]],
    ["138", ["9"]],
    ["139", ["9"]],
    ["140", ["9"]],
    ["141", ["9"]],
    ["142", ["9"]],
    ["143", ["9"]],
    ["144", ["9"]],
    ["145", ["10"]],
    ["146", ["10"]],
    ["147", ["10"]],
    ["148", ["10"]],
    ["149", ["10"]],
    ["150", ["10"]],
    ["151", ["10"]],
    ["152", ["10"]],
    ["153", ["10"]],
    ["154", ["10"]],
    ["155", ["10"]],
    ["156", ["10"]],
    ["157", ["10"]],
    ["158", ["10"]],
    ["159", ["10"]],
    ["160", ["9"]],
    ["161", ["10"]],
    ["162", ["10"]],
    ["163", ["10"]],
    ["164", ["10"]],
    ["165", ["10"]],
    ["166", ["10"]],
    ["167", ["10"]],
    ["168", ["10"]],
    ["169", ["10"]],
    ["170", ["10"]],
    ["171", ["10"]],
    ["172", ["10"]],
    ["173", ["10"]],
    ["174", ["10"]],
    ["175", ["10"]],
    ["176", ["10"]],
    ["177", ["10"]],
    ["178", ["10"]],
    ["179", ["10"]],
    ["180", ["10"]],
    ["181", ["10"]],
    ["182", ["10"]],
    ["183", ["10"]],
    ["184", ["10"]],
    ["185", ["10"]],
    ["186", ["10"]],
    ["187", ["10"]],
    ["188", ["10"]],
    ["189", ["10"]],
    ["190", ["10"]],
    ["191", ["10"]],
    ["192", ["10"]],
    ["193", ["10"]],
    ["194", ["10"]],
    ["195", ["10"]],
    ["196", ["10"]],
    ["197", ["10"]],
    ["198", ["10"]],
    ["199", ["10"]],
    ["200", ["10"]],
    ["201", ["12"]],
    ["202", ["12"]],
    ["203", ["12"]],
    ["204", ["12"]],
    ["205", ["12"]],
    ["206", ["12"]],
    ["207", ["12"]],
    ["208", ["12"]],
    ["209", ["12"]],
    ["210", ["12"]],
    ["211", ["12"]],
    ["212", ["12"]],
    ["213", ["12"]],
    ["214", ["12"]],
    ["215", ["12"]],
    ["216", ["12"]],
    ["217", ["12"]],
    ["218", ["12"]],
    ["219", ["12"]],
    ["220", ["12"]],
    ["221", ["12"]],
    ["222", ["11"]],
    ["223", ["11"]],
    ["224", ["11"]],
    ["225", ["11"]],
    ["226", ["11"]],
    ["227", ["11"]],
    // 228 not valid
    ["229", ["1"]],
    ["230", ["1"]],
    // 231 not valid
    ["232", ["10"]]
]);
const continentsForCountry = (countryId) => {
    return countryContinentMapping.get(countryId);
};
exports.continentsForCountry = continentsForCountry;
const countriesForContinent = (continentId) => {
    const countries = [];
    for (const [country, continents] of countryContinentMapping.entries()) {
        if (continents.includes(continentId)) {
            countries.push(country);
        }
    }
    return countries;
};
exports.countriesForContinent = countriesForContinent;
//# sourceMappingURL=continent-country-mapping.js.map